export const Config = {
  // Auth0 Configuration (safe to be public)
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE,

  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL,

  // App Configuration
  environment: import.meta.env.VITE_ENV || import.meta.env.NODE_ENV,
  isDevEnv: import.meta.env.VITE_ENV === 'development',
  isProdEnv: import.meta.env.VITE_ENV === 'production',
  isStaging: import.meta.env.VITE_ENV === 'staging',

  // Admin specific configuration
  appName: 'Coffice Admin',
  version: '1.0.0',
};

const missingVariables = Object.entries(Config)
  .filter(([_, value]) => value === undefined || value === null || value === '')
  .map(([key, value]) => ({ key, value, type: typeof value }));

if (missingVariables.length > 0) {
  const detailedError = missingVariables
    .map(({ key, value, type }) => `${key}: ${value} (${type})`)
    .join(', ');

  throw new Error(
    `Missing environment variables in admin config (${missingVariables.length} variables): ${detailedError}`,
  );
}
